import { useCallback } from 'react';

import { YesNoSelect, type YesNoSelectProps } from 'src/components/base/controls/YesNoSelect/YesNoSelect';
import { withField } from 'src/helpers';
import { withFieldError } from 'src/helpers/withFieldError';
import type { IFieldProps } from 'src/types';

type YesNoSelectFieldProps = IFieldProps & Omit<YesNoSelectProps, 'onChange'>;

export const YesNoSelectField = withField(
  withFieldError(({ field, form: { setFieldValue, setFieldTouched }, ...rest }: YesNoSelectFieldProps) => {
    const onChange = useCallback(
      async (value: boolean | null) => {
        await setFieldValue(field.name, value, true);
        await setFieldTouched(field.name, true);
      },
      [field.name, setFieldValue, setFieldTouched]
    );

    return <YesNoSelect {...field} {...rest} onChange={onChange} />;
  })
);
